import { protocol } from "renderer-app/src/constants/process";

export const NODE_ENV = process.env.NODE_ENV;

export const FLAT_DOWNLOAD_URL = process.env.FLAT_DOWNLOAD_URL;

// export const PRIVACY_URL_CN = "https://www.flat.apprtc.cn/privacy.html";
// export const PRIVACY_URL = "https://flat.agora.io/privacy.html";

// export const SERVICE_URL_CN = "https://www.flat.apprtc.cn/service.html";
// export const SERVICE_URL = "https://flat.agora.io/service.html";

export const FLAT_REGION = process.env.FLAT_REGION;

export const FLAT_RECORDER_USER_UUIDS = process.env.FLAT_RECORDER_USER_UUIDS;

export const PRIVACY_URL_CN_CN = "https://www.flat.apprtc.cn/privacy.html";
export const PRIVACY_URL_CN_EN = "https://www.flat.apprtc.cn/en/privacy.html";

export const PRIVACY_URL_EN_CN = "https://flat.agora.io/zh/privacy.html";
export const PRIVACY_URL_EN_EN = "https://flat.agora.io/privacy.html";

export const SERVICE_URL_CN_CN = "https://www.flat.apprtc.cn/service.html";
export const SERVICE_URL_CN_EN = "https://www.flat.apprtc.cn/en/service.html";

export const SERVICE_URL_EN_CN = "https://flat.agora.io/zh/service.html";
export const SERVICE_URL_EN_EN = "https://flat.agora.io/service.html";

export const FLAT_WEB_BASE_URL = `${protocol}://${process.env.FLAT_WEB_DOMAIN}`;
